module.exports = __webpack_public_path__ + "img/offices.3fef1f13.png";